// /frontend/src/services/documentService/templateConfig.js
// Importamos correctamente desde PDF-lib
import templatePdfService from './templatePdfService';

/**
 * Configura y registra todas las plantillas PDF disponibles en el sistema
 * Agregar nuevas plantillas aquí para que estén disponibles automáticamente
 */
const configurarPlantillas = () => {
  
  
  // Registrar plantillas adicionales. Ejemplos:
  
  // Ejemplo: Informe de evaluación
  /*
  templatePdfService.registerTemplate('INFORME_EVALUACION', {
    defaultFileName: 'informe_evaluacion.pdf',
    mapperFunction: 'mapDataToInformeEvaluacion'
  });
  
  // Función de mapeo correspondiente
  templatePdfService.registerMapperFunction('mapDataToInformeEvaluacion', async (pdfDoc, formData) => {
    // Lógica de mapeo de datos para el informe de evaluación
    // ...
  });
  */
  
  // AGREGAR NUEVAS PLANTILLAS AQUÍ
  // ------------------------------------
  // Ejemplo: Plan de terapia
  templatePdfService.registerTemplate('PLAN_TERAPIA', {
    defaultFileName: 'plan_terapia.pdf',
    mapperFunction: 'mapDataToPlanTerapia'
  });

  templatePdfService.registerMapperFunction('mapDataToPlanTerapia', async (pdfDoc, formData) => {
    // Obtener páginas
    const pages = pdfDoc.getPages();
    
    // Comentamos la parte que usa StandardFonts y rgb, ya que las usaremos dentro de las funciones de mapeo
    // que ya están definidas en templatePdfService.js
    /*
    // Cargar fuente
    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
    
    // Configuración
    const fontSize = 10;
    const textColor = rgb(0, 0, 0);
    */
    
    // Mapear datos (ajustar coordenadas según el formato del PDF)
    if (pages.length > 0) {
      const page = pages[0];
      const { width, height } = page.getSize();
      
      // Agregar datos según sea necesario...
      // Aquí simplemente accedemos a la página, pero la lógica
      // completa de dibujo se implementa en el servicio
    }
  });

  // Ejemplo: Consentimiento informado
  templatePdfService.registerTemplate('CONSENTIMIENTO_INFORMADO', {
    defaultFileName: 'consentimiento_informado.pdf',
    mapperFunction: 'mapDataToConsentimiento'
  });

  templatePdfService.registerMapperFunction('mapDataToConsentimiento', async (pdfDoc, formData) => {
    // Obtener páginas
    const pages = pdfDoc.getPages();
    
    // Comentamos la parte que usa StandardFonts y rgb
    /*
    // Cargar fuente
    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
    
    // Configuración
    const fontSize = 10;
    const textColor = rgb(0, 0, 0);
    */
    
    // Ejemplo básico de mapeo
    if (pages.length > 0) {
      const page = pages[0];
      const { width, height } = page.getSize();
      
      // La implementación real se hará en el servicio principal
    }
  });

 
};

export default {
  configurarPlantillas
};